var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "91.44mm",
    height: "91.44mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9144 9144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .fil0 {fill:#F0F0F0} .fil1 {fill:#011627;fill-rule:nonzero}  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2744712271136"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "0,0 9144,0 9144,9144 0,9144 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M3897 3810l917 0c47,0 84,38 84,85l0 106c205,-203 345,-201 725,-196 47,0 101,1 201,1 252,0 481,104 647,271 166,168 270,399 270,651l0 1876c0,47 -38,85 -85,85l-917 0c-47,0 -85,-38 -85,-85l0 -1632c0,-104 -42,-199 -111,-267 -68,-69 -163,-111 -267,-111 -97,0 -186,36 -254,95 -66,59 -112,140 -124,231l0 1684c0,47 -37,85 -84,85l-917 0c-47,0 -85,-38 -85,-85l0 -2709c0,-47 38,-85 85,-85zm-1392 0l917 0c46,0 84,38 84,85l0 2709c0,47 -38,85 -84,85l-917 0c-47,0 -85,-38 -85,-85l0 -2709c0,-47 38,-85 85,-85zm832 169l-748 0 0 2540 748 0 0 -2540zm-374 -1524c155,0 295,63 396,164 101,102 164,242 164,396 0,155 -63,295 -164,396 -101,101 -241,164 -396,164 -155,0 -294,-63 -396,-164 -101,-101 -164,-241 -164,-396 0,-154 63,-294 164,-396 102,-101 241,-164 396,-164zm276 284c-70,-71 -168,-114 -276,-114 -108,0 -205,43 -276,114 -71,71 -114,168 -114,276 0,108 43,206 114,276 71,71 168,115 276,115 108,0 206,-44 276,-115 71,-70 115,-168 115,-276 0,-108 -44,-205 -115,-276zm1490 1240l-748 0 0 2540 748 0 0 -1603c0,-3 0,-6 1,-9 15,-137 82,-258 180,-345 98,-86 227,-138 366,-138 151,0 288,62 387,161 99,99 161,236 161,387l0 1547 747 0 0 -1791c0,-206 -84,-395 -220,-532 -135,-136 -322,-221 -527,-221 -50,0 -130,-1 -203,-2 -396,-5 -488,-6 -738,299 -15,22 -40,37 -69,37 -47,0 -85,-38 -85,-85l0 -245z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon5);
export default __webpack_public_path__ + "static/media/nav-icon5.24dd9bc6663229b1a33ff39ac8a60b8b.svg";
export { ForwardRef as ReactComponent };